export * from './base'

export const defaultToken = 'dev_token'
export const defaultDomain = ''

export const env = 'dev'
export const loginUrl = 'https://member.chukouplus.com/user/Index/login.html'
